import { IChuongTrinhDaoTaoKienThucActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoKienThucActions";
import { IChuongTrinhDaoTaoKienThucReducer } from "../../reducer-model/ctdt/IChuongTrinhDaoTaoKienThucReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoKienThucReducer = {
  status: eReducerStatusBase.is_not_initialization,
  chuongTrinhDaoTaoKienThucs: [],
  selectedIds: []
};
export const chuongTrinhDaoTaoKienThucReducer = (
  state: IChuongTrinhDaoTaoKienThucReducer = iniState,
  action: IChuongTrinhDaoTaoKienThucActionTypes
): IChuongTrinhDaoTaoKienThucReducer => {
  switch (action.type) {
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuongTrinhDaoTaoKienThucs: action.payload,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        chuongTrinhDaoTaoKienThucEditing: action.payload
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_loading
      };
    case "CHUONG_TRINH_DAO_TAO_KIEN_THUC_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
